{
  "connections.title": "Bağlı asistanlar",
  "connections.lede": "Hangi asistan istemcilerinin çalışma alanına erişebildiğini tam olarak gör, kataloglarını daralt veya erişimlerini anında iptal et.",
  "connections.never": "Hiçbir zaman",
  "connections.error.generic": "Asistan bağlantısı güncellenemedi. Yeniden dene.",
  "connections.connected.title": "Yetkili istemciler",
  "connections.connected.description": "Yetenek profili keşif boyutunu değiştirir; verilen OAuth kapsamları ise değişmez yetki sınırıdır.",
  "connections.empty.title": "Bağlı asistan yok",
  "connections.empty.description": "Kurulum bilgilerini MCP uyumlu bir istemciye kopyala. İstenen kapsamları OAuth yetkilendirmesi sırasında inceleyeceksin.",
  "connections.status.active": "Etkin",
  "connections.status.revoked": "İptal edildi",
  "connections.lastUsed": "Son kullanım",
  "connections.expires": "Mevcut belirtecin bitişi",
  "connections.profile.label": "Katalog profili",
  "connections.profile.core.label": "Çekirdek",
  "connections.profile.core.description": "Günlük yakalama, bugün, arama ve bağlam için küçük yüzey.",
  "connections.profile.workspace.label": "Çalışma alanı",
  "connections.profile.workspace.description": "Çekirdek ile yetkili çalışma alanlarıyla ilgili araçlar.",
  "connections.profile.document.label": "Belge",
  "connections.profile.document.description": "Verilen OAuth kapsamları içinde sayfaları ve bağlı kayıtları belge odaklı araçlarla oku ve düzenle.",
  "connections.profile.full.label": "Tam",
  "connections.profile.full.description": "Yetkinin izin verdiği tüm işlemler, sayfalanmış katalog üzerinden keşfedilir.",
  "connections.scopes.title": "Verilen kapsamlar",
  "connections.scopes.description": "Katalog profilini değiştirmek yeni kapsam eklemez. Ek yetki istemek için istemciden yeniden bağlan; yeni kapsamları tekrar onaylaman gerekir.",
  "connections.revoke.title": "{{name}} erişimi iptal edilsin mi?",
  "connections.revoke.description": "Bu yetkiye ait erişim ve yenileme belirteçleri çalışmayı bırakır. Bağımsız çalışma alanı kayıtların değişmez.",
  "connections.revoke.action": "Erişimi iptal et",
  "connections.reconnect": "Yeniden bağlantı kurulumunu kopyala",
  "connections.reconnect.description": "Asistan istemcisinden yeniden bağlan ve yeni yetkiyi onayla.",
  "connections.setup.title": "Başka bir asistan bağla",
  "connections.setup.description": "OAuth keşfini kullan; kişisel erişim belirtecini veya hesap parolanı hiçbir zaman bir asistana yapıştırma.",
  "connections.setup.copy": "Kurulumu kopyala",
  "connections.setup.copied": "Kurulum kopyalandı",
  "connections.setup.copyError": "Tarayıcı kurulum bilgilerini kopyalayamadı. Metni seçip elle kopyala.",
  "connections.setup.exampleOrigin": "https://your-exognitos.example",
  "connections.setup.mcpUrl": "MCP adresi: {{url}}",
  "connections.setup.metadataUrl": "Korunan kaynak metaverisi: {{url}}",
  "connections.setup.clientId": "OAuth istemcisi: {{id}}",
  "connections.setup.copyScopeHint": "Yalnızca asistanın mevcut işi için gereken kapsamları yetkilendir.",
  "connections.created": "Bağlantı oluşturuldu",
  "connections.issued": "Mevcut belirteç verildi",
  "connections.registration.label": "Kayıt kaynağı",
  "connections.registration.unknown": "Bilinmiyor veya eski bağlantı",
  "connections.registration.manual": "Elle kaydedilmiş istemci",
  "connections.registration.dcr": "Dinamik istemci kaydı",
  "connections.registration.cimd": "İstemci kimliği metaveri belgesi",
  "connections.scopes.unavailable": "Dağıtım yetenekleri yüklenirken açıklama kullanılamıyor.",
  "connections.authority.title": "Sürekli yetki",
  "connections.authority.description": "Bu yalnızca kısıtlayan politika, bağlantının insan müdahalesi olmadan yapabileceklerini daraltır. OAuth kapsamı eklemez; önizleme, onay veya yakın zamanda kimlik doğrulama gereksinimini kaldırmaz.",
  "connections.authority.risks.title": "İnsan müdahalesi olmadan izin verilen risk sınıfları",
  "connections.authority.risks.R0.label": "R0 · Gerçekleri oku",
  "connections.authority.risks.R0.description": "Seçili çalışma alanlarında yalnızca okuma işlemlerine izin ver.",
  "connections.authority.risks.R1.label": "R1 · Olağan yazmalar",
  "connections.authority.risks.R1.description": "Sınırlandırılmış olağan yazmalara izin ver. Yazma sonuçlarını döndürmek için R0 gerekir.",
  "connections.authority.workspaces.title": "Çalışma alanı tavanı",
  "connections.authority.workspaces.planner": "Planlayıcı",
  "connections.authority.workspaces.projects": "Projeler",
  "connections.authority.workspaces.knowledge": "Bilgi",
  "connections.authority.workspaces.life": "Yaşam",
  "connections.authority.workspaces.analysis": "Analiz",
  "connections.authority.workspaces.extensions": "Eklentiler",
  "connections.authority.budget.label": "Kayan saat başına başarılı R1 yazması",
  "connections.authority.budget.description": "0, insan müdahalesi olmayan yazmaları kapatır; kesin tavan 1.000'dir. Türetilmiş yetkiler bu bağlantının bütçesini paylaşır.",
  "connections.authority.save": "Sürekli yetkiyi kaydet",
  "connections.setup.copyCodex": "Codex yapılandırmasını kopyala",
  "connections.setup.copySnippet": "Parçayı kopyala",
  "connections.setup.mcpLabel": "MCP uç noktası",
  "connections.setup.metadataLabel": "Korunan kaynak keşfi",
  "connections.setup.registration.label": "Canlı kayıt modu",
  "connections.setup.registration.dcr": "Bu dağıtımda dinamik istemci kaydı açık.",
  "connections.setup.registration.cimd": "Dinamik kayıt kapalı; istemci kimliği metaveri belgesi veya elle kaydedilmiş istemci kullan.",
  "connections.setup.registration.unknown": "Dağıtım yetenekleri yüklenirken kayıt modu kullanılamıyor.",
  "connections.setup.requestedScopes": "Önerilen salt okunur kapsamlar",
  "connections.setup.scopeDetails": "Önerilen kapsam açıklamaları",
  "connections.setup.capabilitiesUnavailable": "Canlı yetenek ayrıntıları yüklenemedi. Uç nokta ve yapılandırmalar kopyalanabilir; yetkilendirmeden önce kayıt modunu ve kapsam açıklamalarını doğrula.",
  "connections.setup.guidanceOnly": "OAuth'ı başlatmadan önce sunucuyu yapılandır. Claude ve VS Code blokları kurulum rehberidir; kayda alınmış uyumluluk kanıtı değildir.",
  "connections.setup.scopes": "İstenen kapsamlar: {{scopes}}",
  "connections.setup.client.codex": "Codex",
  "connections.setup.client.claude": "Claude Desktop / Claude Code",
  "connections.setup.client.vscode": "VS Code",
  "connections.setup.codex.loginHint": "Bu TOML dosyasını kaydettikten sonra OAuth'ı terminalden başlat:"
}
